import * as React from 'react'
import styled from 'styled-components'
import { setGAEvent } from '../../../../services/analytics/google-analytics'
import { APP_NAME } from '../../../../static/constants'

const zingTnC = '/webview/terms-and-conditions'
const faqUrl = '/main/faq'
const zingPN = '/webview/privacy-notice'

const StyledDescription = styled.div`
  font-size: 0.875rem;
  padding: 1rem;

  h1.header {
    text-align: center;
    margin: 0;
    margin-bottom: 20px;
    font-size: 1.5rem;
    color: var(--color-primary);
  }
  h3.sub-header {
    text-align: center;
  }

  ul {
    padding-left: 0.8rem;
  }

  a {
    text-decoration: none;
  }
`

const trackLinkOut = label => {
  setGAEvent('button_cta', 'Login - Condensed TnC/PN', label)
}

export const descriptionData = (
  <>
    <header>
      <h1 class="header">{APP_NAME} Update</h1>
      <h3 class="sub-header">Important Updates on Zing Rewards Terms</h3>
    </header>

    <p>
      As previously announced and updated in the Zing Rewards Terms and
      Conditions, Zing Points redemption will no longer be available starting
      January 1, 2025.
    </p>

    <p>
      By continuing, you confirm that you’ve read and accepted the new&nbsp;
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={zingTnC} // link to terms and conditions
        title={`${APP_NAME} Terms and Conditions`}
        onClick={() => trackLinkOut('Terns & Conditions')}
      >
        Terms
      </a>
      . For any questions, reach us through AskZing or check our{' '}
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={faqUrl} // link to FAQ
        title={`${APP_NAME} Frequently Asked Questions`}
        onClick={() => trackLinkOut('Frequently Asked Questions')}
      >
        FAQs
      </a>
      .
    </p>
  </>
)

export const Description = () => (
  <StyledDescription>{descriptionData}</StyledDescription>
)

function TnCAndPNConsent(props) {
  return (
    <aside {...props}>
      <Description />
    </aside>
  )
}

export default TnCAndPNConsent
